import React from "react";
import { Flame } from "lucide-react";
import { useMT } from "../lib/miniI18n";

export const STREAK_BADGES = [
  { id: "streak_3", days: 3, icon: "🔥", label: "3-day" },
  { id: "streak_7", days: 7, icon: "⚡", label: "7-day", bonus: true },
  { id: "streak_14", days: 14, icon: "💎", label: "14-day" },
  { id: "streak_30", days: 30, icon: "👑", label: "30-day" },
];

/* Customer daily-play streak: current count + 4 milestone badges (₹ bonus at 7 days) */
export function StreakBadges({ user }) {
  const mt = useMT();
  if (!user) return null;
  const count = user.play_streak?.count || 0;
  const have = new Set(user.streak_badges || []);
  const next = STREAK_BADGES.find((b) => count < b.days);
  return (
    <div className="mb-2 rounded-xl bg-orange-500/15 border border-orange-400/40 px-3 py-1.5 flex items-center gap-2" data-testid="play-streak-badge">
      <Flame className="w-3.5 h-3.5 text-orange-400 shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-[11px] text-orange-100 leading-tight"><b>{count}-{mt("day streak")}</b>{next && <span className="text-orange-200/80"> · {next.days - count} {mt("more for")} {next.icon} {next.label}{next.bonus ? " + ₹" : ""}</span>}</div>
      </div>
      <div className="flex gap-1" data-testid="streak-badges">
        {STREAK_BADGES.map((b) => <span key={b.id} title={`${b.label} streak`} className={`w-6 h-6 rounded-full flex items-center justify-center text-xs border ${have.has(b.id) || count >= b.days ? "bg-amber-400/90 border-amber-200" : "bg-black/30 border-white/10 grayscale opacity-50"}`} data-testid={`streak-badge-${b.id}`}>{b.icon}</span>)}
      </div>
    </div>
  );
}
